import {create} from 'zustand';
import {UseSelectedRequestIndexStoreProps} from './types';

export const useSelectedRequestIndexStore = create<UseSelectedRequestIndexStoreProps>(
	(set, get) => ({
		index: 0,
		setIndex: index => set({index}),
		resetIndex: () => set({index: 0}),
		nextIndex: () => set({index: get().index + 1}),
		previousIndex: () => set({index: get().index - 1}),
	}),
);
